/**
 * What is on the tablet now, live (BA-85): the sent schedule nodes, the current action,
 * the tablet's last_seen and the dashboard's own connection. Schedules and Controls share it.
 */

import { useEffect, useState } from 'react';
import { CurrentAction } from '../types/currentAction';
import { SentSchedule } from '../types/sentSchedule';
import { isTabletOffline } from '../utils/sentSchedule';
import { useCurrentAction } from './useCurrentAction';
import { useDeviceLastSeen } from './useDeviceLastSeen';
import { useOnline } from './useOnline';
import { useSentSchedule } from './useSentSchedule';

export interface TabletNow {
  sentSchedule: SentSchedule | null;
  previousSentSchedule: SentSchedule | null;
  currentAction: CurrentAction | null;
  /** sentSchedule, previousSentSchedule and currentAction have all delivered a first value (n2) */
  ready: boolean;
  lastSeen: number | null;
  tabletOffline: boolean;
  online: boolean;
  /** Ticks every 30 s, for "N min ago" and the offline rule */
  now: number;
}

export function useTabletNow(deviceId: string): TabletNow {
  const { sentSchedule, previousSentSchedule, loaded } = useSentSchedule(deviceId);
  const { currentAction, loading: actionLoading } = useCurrentAction(deviceId);
  const lastSeen = useDeviceLastSeen(deviceId);
  const online = useOnline();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(interval);
  }, []);

  return {
    sentSchedule,
    previousSentSchedule,
    currentAction,
    ready: loaded && !actionLoading,
    lastSeen,
    tabletOffline: isTabletOffline(lastSeen, now),
    online,
    now,
  };
}
